import { serializeBigIntKeys } from "@umi/shared/bigint";


type UmiErrorMetadata = Readonly<Record<string, unknown>>;

interface UmiRichError extends Error {
  readonly metadata: UmiErrorMetadata;
}

const isUmiRichError = (e: unknown): e is UmiRichError => {
  return e instanceof Error
    && "metadata" in e
    && typeof (e as UmiRichError).metadata === "object"
    && (e as UmiRichError).metadata !== null;
};

export const enrichSentryEvent = <T extends { contexts?: Record<string, any> }>(
  event: T,
  hint: { originalException?: unknown }
): T => {
  const ex = hint.originalException;
  if (isUmiRichError(ex)) {
    const prev = event.contexts?.umi;
    const umiCtx = typeof prev === "object" && prev !== null ? { ...prev } : {};
    event.contexts = {
      ...event.contexts,
      umi: { ...umiCtx, metadata: serializeBigIntKeys(ex.metadata) },
    };
  }
  return event;
};
